import React, { useState } from "react";
import "./Booklet.css";

const BookletSlotModal = ({ show, onClose, slot, pageNo, onBookClick }) => {
  const [paymentType, setPaymentType] = useState("full");
  const [partialAmount, setPartialAmount] = useState("");
  const [partialError, setPartialError] = useState("");

  if (!show || !slot) return null;

  const { amount, gstPercentage, gstAmount, totalAmount, position } = slot;

  // Minimum partial = 10% of total slot amount, rounded up to nearest paisa
  const minPartial = Math.ceil(totalAmount * 0.10 * 100) / 100;
  const maxPartial = totalAmount - 0.01;

  const handlePartialChange = (e) => {
    const val = e.target.value;
    setPartialAmount(val);
    const num = parseFloat(val);
    if (!val || isNaN(num)) {
      setPartialError("Please enter an amount");
    } else if (num < minPartial) {
      setPartialError(`Minimum partial payment is ₹${minPartial.toFixed(2)} (10% of total)`);
    } else if (num >= totalAmount) {
      setPartialError(`For full payment select "Full Payment" option`);
    } else {
      setPartialError("");
    }
  };

  const handleProceed = () => {
    if (paymentType === "partial") {
      const num = parseFloat(partialAmount);
      if (!partialAmount || isNaN(num) || num < minPartial || num >= totalAmount) {
        setPartialError(`Enter a valid amount between ₹${minPartial.toFixed(2)} and ₹${maxPartial.toFixed(2)}`);
        return;
      }
      onBookClick(slot, "partial", num);
    } else {
      onBookClick(slot, "full", totalAmount);
    }
  };

  const pendingIfPartial =
    paymentType === "partial" && partialAmount && !isNaN(parseFloat(partialAmount))
      ? Math.max(0, totalAmount - parseFloat(partialAmount)).toFixed(2)
      : null;

  return (
    <div className="slot-popup-overlay">
      <div className="slot-popup-modal enhanced-modal payment-summary-modal">
        <h4 className="fw-bold mb-3 text-center">Payment Summary</h4>

        <p className="text-center text-muted mb-3">Booklet Advertisement Slot</p>

        <div className="summary-row">
          <span>Page</span>
          <span>{pageNo}</span>
        </div>
        <div className="summary-row">
          <span>Position</span>
          <span>{position}</span>
        </div>
        <hr />

        <div className="summary-row">
          <span>Base Amount</span>
          <span>₹{amount.toFixed(2)}</span>
        </div>
        <div className="summary-row">
          <span>GST ({gstPercentage}%)</span>
          <span>₹{gstAmount.toFixed(2)}</span>
        </div>
        <hr />

        <div className="summary-row total-row">
          <strong>Total Amount</strong>
          <strong className="text-success">₹{totalAmount.toFixed(2)}</strong>
        </div>

        {/* Payment Type Toggle */}
        <div className="mt-3 mb-2">
          <p className="fw-semibold mb-2" style={{ fontSize: 14 }}>Payment Option</p>
          <div className="d-flex gap-2">
            <button
              type="button"
              className={`btn btn-sm flex-fill ${paymentType === "full" ? "btn-success" : "btn-outline-secondary"}`}
              onClick={() => { setPaymentType("full"); setPartialAmount(""); setPartialError(""); }}
            >
              Full Payment
            </button>
            <button
              type="button"
              className={`btn btn-sm flex-fill ${paymentType === "partial" ? "btn-warning" : "btn-outline-secondary"}`}
              onClick={() => setPaymentType("partial")}
            >
              Partial Payment
            </button>
          </div>
        </div>

        {paymentType === "partial" && (
          <div className="mt-2">
            <label className="form-label" style={{ fontSize: 13 }}>
              Amount to Pay Now (₹{minPartial.toFixed(2)} – ₹{maxPartial.toFixed(2)})
            </label>
            <input
              type="number"
              className={`form-control form-control-sm ${partialError ? "is-invalid" : ""}`}
              value={partialAmount}
              onChange={handlePartialChange}
              placeholder={`e.g. ${(totalAmount / 2).toFixed(0)}`}
              min={minPartial}
              max={maxPartial}
              step="0.01"
            />
            {partialError && <div className="invalid-feedback">{partialError}</div>}
            {pendingIfPartial && !partialError && (
              <div className="mt-1" style={{ fontSize: 12, color: "#dc3545" }}>
                Pending after this payment: <strong>₹{pendingIfPartial}</strong>
              </div>
            )}
          </div>
        )}

        <div className="d-flex justify-content-between gap-3 mt-4">
          <button className="btn btn-light w-50" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-success w-50" onClick={handleProceed}>
            Proceed to Pay
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookletSlotModal;
